import { VOUCHERS_ROUTES } from '../../constants/_routes'
import vouchersTypes from '../../constants/vouchersTypes'
import { axios } from '../../services'
import { current_timestamp } from '../../helpers'

// INDEX
const vouchers_index_request = () => {
  return {
    type: vouchersTypes.index.request
  }
}

const vouchers_index_success = (response) => {
  return {
    type: vouchersTypes.index.success,
    payload: response.data
  }
}

const vouchers_index_failure = (messages) => {
  return {
    type: vouchersTypes.index.failure,
    payload: messages
  }
}

const vouchers_index = (page=1, per_page=10, filters={}, sort="", order="") => {
  return function (dispatch) {
    // Before Request
    dispatch(vouchers_index_request())

    // Request
    axios.get(
      VOUCHERS_ROUTES.index,
      {
        params: {
          page: page,
          per_page: per_page,
          sort: sort,
          order: order,
          filters: filters,
          serial: current_timestamp()
        }
      }
    ).then( response => {
      // success
      dispatch( vouchers_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching vouchers."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( vouchers_index_failure(errors))
    })
  }

}

const vouchers_select_success = (response) => {
  return {
    type: vouchersTypes.index.select,
    payload: response.data
  }
}


const vouchers_select = () => {
  return function (dispatch) {
    // Before Request
    dispatch(vouchers_index_request())

    // Request
    axios.get(
      VOUCHERS_ROUTES.select
    ).then( response => {
      // success
      dispatch( vouchers_select_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching vouchers."]
      }
      dispatch( vouchers_index_failure(errors))
    })
  }
}

export {
  vouchers_index,
  vouchers_select
}



// WEBPACK FOOTER //
// ./src/js/actions/vouchers/getindex.js